__turbopack_context__.v({
  "link-chip": "LinkChip-module-scss-module__EG-3dG__link-chip",
});
